import { config } from "../../config";
import axios from "axios";

import { User } from '../../entity/authentication/user';
import { VehicleModel } from '../../entity/vehicle/model';
import { Vehicle } from '../../entity/vehicle/vehicle';
import { VehicleType } from '../../entity/vehicle/type';
import { VehicleMake } from '../../entity/vehicle/make';
import { VehicleChargeSocketType } from '../../entity/vehicle/charge-socket-type';
import { VehicleStatus } from '@/entity/vehicle/vehicle-status';
import { LocalStorage } from '@/data/localstorage';
import { EVehicleTransformer } from '../transformers/vehicle';

export class VehicleService {

    async makesOfType(type: VehicleType): Promise<VehicleModel[]> {        
        let userId = window.localStorage.getItem('user.id')
        let response = await axios.get(config.api.host + "/accounts/" + userId + "/vehicles/makes/" + type.id, {
            headers: {
                Authorization: new LocalStorage().authToken
            }            
        })
        let makesInfos: any[] = response.data.data
        let makes: VehicleMake[] = []
        makesInfos.forEach(makeInfo => {           
            makes.push(new VehicleMake(
                makeInfo.code,
                makeInfo.description
            ))
        });
        return Promise.resolve(makes)
    }

    async modelsOfMake(make: VehicleMake): Promise<VehicleModel[]> {        
        let userId = window.localStorage.getItem('user.id')
        let response = await axios.get(config.api.host + "/accounts/" + userId + "/vehicles/models/" + make.id, {
            headers: {
                Authorization: new LocalStorage().authToken
            }            
        })
        let modelsInfos: any[] = response.data.data
        let models: VehicleModel[] = []
        modelsInfos.forEach(modelInfo => {           
            models.push(new VehicleModel(
                modelInfo.code,
                modelInfo.description
            ))
        });
        return Promise.resolve(models)
    }

    async chargerSocketTypesOfVehicleType(vehicleType: VehicleType): Promise<VehicleChargeSocketType[]> {        
        let userId = window.localStorage.getItem('user.id')
        let response = await axios.get(config.api.host + "/accounts/" + userId + "/vehicles/sockets/" + vehicleType.id, {
            headers: {
                Authorization: new LocalStorage().authToken
            }            
        })
        let chargerSocketTypesInfos: any[] = response.data.data
        let chargerSocketTypes: VehicleChargeSocketType[] = []
        chargerSocketTypesInfos.forEach(chargerSocketTypeInfo => {           
            chargerSocketTypes.push(new VehicleChargeSocketType(
                chargerSocketTypeInfo.code,
                chargerSocketTypeInfo.description
            ))
        });
        return Promise.resolve(chargerSocketTypes)
    }

    async types(): Promise<VehicleType[]> {        
        let userId = window.localStorage.getItem('user.id')
        let response = await axios.get(config.api.host + "/accounts/" + userId + "/vehicles/types", {
            headers: {
                Authorization: new LocalStorage().authToken
            }            
        })
        let vehicleTypesInfos: any[] = response.data.data
        let vehicleTypes: VehicleType[] = []
        vehicleTypesInfos.forEach(vehicleTypeInfo => {           
            vehicleTypes.push(new VehicleType(
                vehicleTypeInfo.code,
                vehicleTypeInfo.description
            ))
        });
        return Promise.resolve(vehicleTypes)
    }    

    async addVehicleOfUser(vehicle: Vehicle, user: User): Promise<Vehicle> {
        let userInfo = {
            userId: user.id
        }
        let vehicleInfo = new EVehicleTransformer().deTransform(vehicle)
        let response = await axios.post(config.api.host + "/accounts/" + user.id + "/vehicles", {
            data: {
                ...userInfo,
                registrationType: {
                    code: "R"
                },
                ...vehicleInfo
            }
        }, {
            headers: {
                Authorization: new LocalStorage().authToken
            }            
        })
        let addedVehicle = new EVehicleTransformer().transform(response.data.data)
        return Promise.resolve(addedVehicle)
    }

    async addVehicleForReservationForUser(vehicle: Vehicle, user: User): Promise<Vehicle> {
        let userInfo = {
            userId: user.id
        }
        let vehicleInfo = new EVehicleTransformer().deTransform(vehicle)
        let response = await axios.post(config.api.host + "/accounts/" + user.id + "/vehicles", {
            data: {
                ...userInfo,
                registrationType: {
                    code: "U"
                },
                ...vehicleInfo
            }
        }, {
            headers: {
                Authorization: new LocalStorage().authToken
            }            
        })
        let addedVehicle = new EVehicleTransformer().transform(response.data.data)
        return Promise.resolve(addedVehicle)
    }

    async updateVehicleOfUser(vehicle: Vehicle, user: User): Promise<Vehicle> {
        let userInfo = {
            userId: user.id
        }
        let vehicleInfo = new EVehicleTransformer().deTransform(vehicle)
        let response = await axios.put(config.api.host + "/accounts" + "/" + user.id + "/vehicles"+ "/" + vehicle.id, {
            data: {
                ...userInfo,
                ...vehicleInfo
            }
        }, {
            headers: {
                Authorization: new LocalStorage().authToken
            }            
        })
        let updatedVehicle = new EVehicleTransformer().transform(response.data.data)
        return Promise.resolve(updatedVehicle)
    }

    async deleteVehicleForUser(vehicle: Vehicle, user: User): Promise<void> {
        let response = await axios.put(config.api.host + "/accounts" + "/" + user.id + "/vehicles"+ "/" + vehicle.id + "/cancel", {

        }, {
            headers: {
                Authorization: new LocalStorage().authToken
            }            
        })
        return Promise.resolve()
    }
    
    async vehiclesOfUser(user: User): Promise<Vehicle[]> {       
        let response = await axios.get(config.api.host + "/accounts/" + user.id + "/vehicles?data[page]=1&data[userId]="+ user.id +"&data[page-size]=1000", {
            headers: {
                Authorization: new LocalStorage().authToken
            }            
        })
        let vehiclesInfos: any[] = response.data.data        
        let vehicles: Vehicle[] = []
        vehiclesInfos.forEach(vehicleInfo => {
            vehicles.push(new EVehicleTransformer().transform(vehicleInfo))
        });
        return Promise.resolve(vehicles)
    }

    async vehicleWithId(id: number): Promise<Vehicle> {
        let userId = window.localStorage.getItem('user.id')
        let response = await axios.get(config.api.host + "/accounts" + "/" + userId + "/vehicles" + "/" + id, {
            headers: {
                Authorization: new LocalStorage().authToken
            }            
        })
        let vehicleInfo = response.data.data
        return new EVehicleTransformer().transform(vehicleInfo)
    }
}